module.exports = __webpack_public_path__ + "static/media/david-gonzales-2406949.879e56dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Imgs/david-gonzales-2406949.jpg
// module id = 75
// module chunks = 0